import { Axios } from "../axios";

export type VkycPublicResponse = {
  valid?: boolean;
  captureExpiresAt?: string;
  adIiKycStatus?: string;
  captureLink?: string;
  expired?: boolean;
  success?: boolean;
  name?: string;
  completed?: boolean;
  message?: string | null;
  status?: string;
};

const publicHeaders = {
  "Content-Type": "application/json",
};

export const vkycApi = {
  /** Public vKYC lookup — no Authorization header. */
  async getPublicVkyc(token: string) {
    return await Axios.get<VkycPublicResponse>(`/remit/kyc/vkyc/public/${token}`, {
      headers: publicHeaders,
    });
  },
};

export const parseVkycPublicResponse = (response: any): VkycPublicResponse | null => {
  const data = response?.data ?? response;
  if (!data || typeof data !== "object") return null;
  return data as VkycPublicResponse;
};
